// apps/web/src/offline/db.js

const DB_NAME =
    'nlb-games-offline'

const DB_VERSION =
    3

export const STORES = {
    GAMES:
        'games',

    LEAD_FORMS:
        'leadForms',

    PRIZES:
        'prizes',

    LEADS:
        'leads',

    SPINS:
        'spins',

    SYNC_QUEUE:
        'syncQueue',

    META:
        'meta',

    ASSETS:
        'assets',
}

let databasePromise =
    null

// ======================================================
// ABRIR BANCO
// ======================================================

const openDatabase =
    () => {
        if (
            databasePromise
        ) {
            return databasePromise
        }

        databasePromise =
            new Promise(
                (
                    resolve,
                    reject,
                ) => {
                    if (
                        !(
                            'indexedDB'
                            in window
                        )
                    ) {
                        reject(
                            new Error(
                                'IndexedDB não é suportado neste navegador',
                            ),
                        )

                        return
                    }

                    const request =
                        window.indexedDB.open(
                            DB_NAME,
                            DB_VERSION,
                        )

                    // ======================================
                    // CRIAR / ATUALIZAR ESTRUTURA
                    // ======================================

                    request.onupgradeneeded =
                        (
                            event,
                        ) => {
                            const db =
                                event
                                    .target
                                    .result

                            console.log(
                                '[OFFLINE DB] Atualizando banco:',
                                {
                                    oldVersion:
                                        event
                                            .oldVersion,

                                    newVersion:
                                        event
                                            .newVersion,
                                },
                            )

                            // ==============================
                            // JOGOS
                            // ==============================

                            if (
                                !db
                                    .objectStoreNames
                                    .contains(
                                        STORES
                                            .GAMES,
                                    )
                            ) {
                                const store =
                                    db.createObjectStore(
                                        STORES
                                            .GAMES,
                                        {
                                            keyPath:
                                                'id',
                                        },
                                    )

                                store.createIndex(
                                    'slug',
                                    'slug',
                                    {
                                        unique:
                                            true,
                                    },
                                )

                                store.createIndex(
                                    'updatedAt',
                                    'offlineUpdatedAt',
                                    {
                                        unique:
                                            false,
                                    },
                                )
                            }

                            // ==============================
                            // FORMULÁRIOS
                            // ==============================

                            if (
                                !db
                                    .objectStoreNames
                                    .contains(
                                        STORES
                                            .LEAD_FORMS,
                                    )
                            ) {
                                const store =
                                    db.createObjectStore(
                                        STORES
                                            .LEAD_FORMS,
                                        {
                                            keyPath:
                                                'gameId',
                                        },
                                    )

                                store.createIndex(
                                    'updatedAt',
                                    'offlineUpdatedAt',
                                    {
                                        unique:
                                            false,
                                    },
                                )
                            }

                            // ==============================
                            // PRÊMIOS
                            // ==============================

                            if (
                                !db
                                    .objectStoreNames
                                    .contains(
                                        STORES
                                            .PRIZES,
                                    )
                            ) {
                                const store =
                                    db.createObjectStore(
                                        STORES
                                            .PRIZES,
                                        {
                                            keyPath:
                                                'gameId',
                                        },
                                    )

                                store.createIndex(
                                    'updatedAt',
                                    'offlineUpdatedAt',
                                    {
                                        unique:
                                            false,
                                    },
                                )
                            }

                            // ==============================
                            // LEADS OFFLINE
                            // ==============================

                            if (
                                !db
                                    .objectStoreNames
                                    .contains(
                                        STORES
                                            .LEADS,
                                    )
                            ) {
                                const store =
                                    db.createObjectStore(
                                        STORES
                                            .LEADS,
                                        {
                                            keyPath:
                                                'localId',
                                        },
                                    )

                                store.createIndex(
                                    'gameId',
                                    'gameId',
                                    {
                                        unique:
                                            false,
                                    },
                                )

                                store.createIndex(
                                    'syncStatus',
                                    'syncStatus',
                                    {
                                        unique:
                                            false,
                                    },
                                )

                                store.createIndex(
                                    'createdAt',
                                    'createdAt',
                                    {
                                        unique:
                                            false,
                                    },
                                )
                            }

                            // ==============================
                            // GIROS OFFLINE
                            // ==============================

                            if (
                                !db
                                    .objectStoreNames
                                    .contains(
                                        STORES
                                            .SPINS,
                                    )
                            ) {
                                const store =
                                    db.createObjectStore(
                                        STORES
                                            .SPINS,
                                        {
                                            keyPath:
                                                'localId',
                                        },
                                    )

                                store.createIndex(
                                    'gameId',
                                    'gameId',
                                    {
                                        unique:
                                            false,
                                    },
                                )

                                store.createIndex(
                                    'syncStatus',
                                    'syncStatus',
                                    {
                                        unique:
                                            false,
                                    },
                                )

                                store.createIndex(
                                    'createdAt',
                                    'createdAt',
                                    {
                                        unique:
                                            false,
                                    },
                                )
                            }

                            // ==============================
                            // FILA DE SINCRONIZAÇÃO
                            // ==============================

                            if (
                                !db
                                    .objectStoreNames
                                    .contains(
                                        STORES
                                            .SYNC_QUEUE,
                                    )
                            ) {
                                const store =
                                    db.createObjectStore(
                                        STORES
                                            .SYNC_QUEUE,
                                        {
                                            keyPath:
                                                'id',
                                        },
                                    )

                                store.createIndex(
                                    'status',
                                    'status',
                                    {
                                        unique:
                                            false,
                                    },
                                )

                                store.createIndex(
                                    'type',
                                    'type',
                                    {
                                        unique:
                                            false,
                                    },
                                )

                                store.createIndex(
                                    'createdAt',
                                    'createdAt',
                                    {
                                        unique:
                                            false,
                                    },
                                )
                            }

                            // ==============================
                            // META
                            // ==============================

                            if (
                                !db
                                    .objectStoreNames
                                    .contains(
                                        STORES
                                            .META,
                                    )
                            ) {
                                db.createObjectStore(
                                    STORES
                                        .META,
                                    {
                                        keyPath:
                                            'key',
                                    },
                                )
                            }

                            // ==============================
                            // ASSETS OFFLINE
                            //
                            // Imagens, logos, fundos,
                            // vídeos e demais mídias.
                            // ==============================

                            if (
                                !db
                                    .objectStoreNames
                                    .contains(
                                        STORES
                                            .ASSETS,
                                    )
                            ) {
                                const store =
                                    db.createObjectStore(
                                        STORES
                                            .ASSETS,
                                        {
                                            keyPath:
                                                'url',
                                        },
                                    )

                                store.createIndex(
                                    'gameId',
                                    'gameId',
                                    {
                                        unique:
                                            false,
                                    },
                                )

                                store.createIndex(
                                    'updatedAt',
                                    'updatedAt',
                                    {
                                        unique:
                                            false,
                                    },
                                )

                                store.createIndex(
                                    'contentType',
                                    'contentType',
                                    {
                                        unique:
                                            false,
                                    },
                                )
                            }
                        }

                    // ======================================
                    // SUCESSO
                    // ======================================

                    request.onsuccess =
                        () => {
                            const db =
                                request
                                    .result

                            console.log(
                                '[OFFLINE DB] Banco aberto:',
                                {
                                    name:
                                        db.name,

                                    version:
                                        db.version,

                                    stores:
                                        Array.from(
                                            db
                                                .objectStoreNames,
                                        ),
                                },
                            )

                            db.onversionchange =
                                () => {
                                    console.warn(
                                        '[OFFLINE DB] Nova versão detectada. Fechando conexão atual.',
                                    )

                                    db.close()

                                    databasePromise =
                                        null
                                }

                            resolve(
                                db,
                            )
                        }

                    // ======================================
                    // ERRO
                    // ======================================

                    request.onerror =
                        () => {
                            databasePromise =
                                null

                            reject(
                                request
                                    .error ||
                                new Error(
                                    'Não foi possível abrir o banco offline',
                                ),
                            )
                        }

                    // ======================================
                    // BLOQUEADO
                    // ======================================

                    request.onblocked =
                        () => {
                            console.warn(
                                '[OFFLINE DB] Atualização bloqueada por outra aba. Feche outras abas da plataforma.',
                            )
                        }
                },
            )

        return databasePromise
    }

// ======================================================
// GERAR ID LOCAL
// ======================================================

export const createLocalId =
    (
        prefix =
            'local',
    ) => {
        if (
            window
                .crypto
                ?.randomUUID
        ) {
            return `${prefix}_${window.crypto.randomUUID()}`
        }

        return `${prefix}_${Date.now()}_${Math.random()
            .toString(
                36,
            )
            .slice(
                2,
            )}`
    }

// ======================================================
// PUT
// ======================================================

export const dbPut =
    async (
        storeName,
        value,
    ) => {
        const db =
            await openDatabase()

        return new Promise(
            (
                resolve,
                reject,
            ) => {
                const transaction =
                    db.transaction(
                        storeName,
                        'readwrite',
                    )

                const store =
                    transaction.objectStore(
                        storeName,
                    )

                const request =
                    store.put(
                        value,
                    )

                request.onsuccess =
                    () => {
                        resolve(
                            value,
                        )
                    }

                request.onerror =
                    () => {
                        reject(
                            request
                                .error,
                        )
                    }
            },
        )
    }

// ======================================================
// GET
// ======================================================

export const dbGet =
    async (
        storeName,
        key,
    ) => {
        const db =
            await openDatabase()

        return new Promise(
            (
                resolve,
                reject,
            ) => {
                const transaction =
                    db.transaction(
                        storeName,
                        'readonly',
                    )

                const store =
                    transaction.objectStore(
                        storeName,
                    )

                const request =
                    store.get(
                        key,
                    )

                request.onsuccess =
                    () => {
                        resolve(
                            request
                                .result ||
                            null,
                        )
                    }

                request.onerror =
                    () => {
                        reject(
                            request
                                .error,
                        )
                    }
            },
        )
    }

// ======================================================
// DELETE
// ======================================================

export const dbDelete =
    async (
        storeName,
        key,
    ) => {
        const db =
            await openDatabase()

        return new Promise(
            (
                resolve,
                reject,
            ) => {
                const transaction =
                    db.transaction(
                        storeName,
                        'readwrite',
                    )

                const store =
                    transaction.objectStore(
                        storeName,
                    )

                const request =
                    store.delete(
                        key,
                    )

                request.onsuccess =
                    () => {
                        resolve(
                            true,
                        )
                    }

                request.onerror =
                    () => {
                        reject(
                            request
                                .error,
                        )
                    }
            },
        )
    }

// ======================================================
// GET ALL
// ======================================================

export const dbGetAll =
    async (
        storeName,
    ) => {
        const db =
            await openDatabase()

        return new Promise(
            (
                resolve,
                reject,
            ) => {
                const transaction =
                    db.transaction(
                        storeName,
                        'readonly',
                    )

                const store =
                    transaction.objectStore(
                        storeName,
                    )

                const request =
                    store.getAll()

                request.onsuccess =
                    () => {
                        resolve(
                            request
                                .result ||
                            [],
                        )
                    }

                request.onerror =
                    () => {
                        reject(
                            request
                                .error,
                        )
                    }
            },
        )
    }

// ======================================================
// GET POR INDEX
// ======================================================

export const dbGetByIndex =
    async (
        storeName,
        indexName,
        value,
    ) => {
        const db =
            await openDatabase()

        return new Promise(
            (
                resolve,
                reject,
            ) => {
                const transaction =
                    db.transaction(
                        storeName,
                        'readonly',
                    )

                const store =
                    transaction.objectStore(
                        storeName,
                    )

                const index =
                    store.index(
                        indexName,
                    )

                const request =
                    index.get(
                        value,
                    )

                request.onsuccess =
                    () => {
                        resolve(
                            request
                                .result ||
                            null,
                        )
                    }

                request.onerror =
                    () => {
                        reject(
                            request
                                .error,
                        )
                    }
            },
        )
    }

// ======================================================
// GET ALL POR INDEX
// ======================================================

export const dbGetAllByIndex =
    async (
        storeName,
        indexName,
        value,
    ) => {
        const db =
            await openDatabase()

        return new Promise(
            (
                resolve,
                reject,
            ) => {
                const transaction =
                    db.transaction(
                        storeName,
                        'readonly',
                    )

                const store =
                    transaction.objectStore(
                        storeName,
                    )

                const index =
                    store.index(
                        indexName,
                    )

                const request =
                    index.getAll(
                        value,
                    )

                request.onsuccess =
                    () => {
                        resolve(
                            request
                                .result ||
                            [],
                        )
                    }

                request.onerror =
                    () => {
                        reject(
                            request
                                .error,
                        )
                    }
            },
        )
    }

// ======================================================
// LIMPAR STORE
// ======================================================

export const clearStore =
    async (
        storeName,
    ) => {
        const db =
            await openDatabase()

        return new Promise(
            (
                resolve,
                reject,
            ) => {
                const transaction =
                    db.transaction(
                        storeName,
                        'readwrite',
                    )

                const store =
                    transaction.objectStore(
                        storeName,
                    )

                const request =
                    store.clear()

                request.onsuccess =
                    () => {
                        resolve(
                            true,
                        )
                    }

                request.onerror =
                    () => {
                        reject(
                            request
                                .error,
                        )
                    }
            },
        )
    }

// ======================================================
// ACESSO DIRETO AO BANCO
// ======================================================

export const getOfflineDatabase =
    openDatabase